<template>
  <v-card class="with-shadow rounded" v-if="loaded">
    <v-card-title class="headline">
      Jenis Surat Masuk
    </v-card-title>
    <v-card-text>
      <PieChart v-if="loaded" :chartdata="chartData" :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
import PieChart from '../../chart/PieChart'
import { inboxCategoriesSummary } from '@/services/dashboard'

export default {
  props: {
    id_pengolah: { type: Number, default: null }
  },
  components: { PieChart },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' }
      }
    }
  },
  watch: {
    id_pengolah: function(value) {
      this.loadData(value)
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData(id_pengolah = null) {
      try {
        this.loaded = false
        const { data } = await inboxCategoriesSummary(id_pengolah)
        this.chartData = data
      } catch (error) {
        // console.log(error)
      } finally {
        this.loaded = true
      }
    }
  }
}
</script>

<style></style>
